var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contens"},[_c('h3',[_vm._v("企业端数据联通测试")]),_c('h3',[_vm._v("请求当前票号："+_vm._s(_vm.newData))]),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getData}},[_vm._v("测试请求企业端票号")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }